import { Component } from "react";
import { IBodyshopService } from "../UserService";

import LoaderCommon from "../Loader/LoaderCommon";
import { FaEnvelope, FaFax, FaMapPin, FaPhone } from "react-icons/fa";
require("./styles.scss");

interface Props {
  ibsService: IBodyshopService;
}
interface State {
  showLoader: boolean;
}

export default class ContactUs extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.props.ibsService.currentUser = JSON.parse(
      localStorage.getItem("currentUser") as any
    ) as any;

    this.state = {
      showLoader: false,
    };
  }

  componentDidMount(): void {}

  render() {
    return (
      <>
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={"Loading..."} />
        ) : undefined}
        <div className="contact-container">
          <div className="contact-header">
            <div className="contact-header-overlay"></div>
            <h1>Contact Us</h1>
          </div>
          <div className="contact-body">
            <div className="contact-body-left">
              {/* <EmbedToggler defaultToggledOn> */}
              {/* <FacebookEmbed
                  url="https://www.facebook.com/v8.0/plugins/page.php?adapt_container_width=true&app_id=250139598713176&channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3345eded4441c%26domain%3Dflowautobody.com.au%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fflowautobody.com.au%252Ff2aaf0a4b6a4598%26relation%3Dparent.parent&container_width=0&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2FFlowAutobody%2F&locale=en_US&sdk=joey&show_facepile=true&small_header=false&tabs=messages%2C%20timeline&width="
                  width={325}
                /> */}
              {/* </EmbedToggler> */}
            </div>
            <div className="contact-body-right">
              <h3 className="title">Let's get in touch!</h3>
              <p className="subtitle">We'd love to hear from you.</p>
              <div className="phones-container">
                <a className="contact-wrapper" href="tel:0733543711">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <p>07 3354 3711</p>
                </a>
                <a className="contact-wrapper" href="tel:0733542228">
                  <div className="contact-icon">
                    <FaFax />
                  </div>
                  <p>07 3354 2228</p>
                </a>
              </div>
              <a
                className="address-container contact-wrapper"
                href="https://www.google.com/maps/place/Flow+Autobody/@-27.41808,152.9913919,17z/data=!4m13!1m7!3m6!1s0x6b9157748dcf3b43:0x975c92977c38c430!2s256+S+Pine+Rd,+Enoggera+QLD+4051!3b1!8m2!3d-27.41808!4d152.9935806!3m4!1s0x6b915774ed913c9b:0x787592295017734!8m2!3d-27.41808!4d152.9935806"
                target="_blank"
                rel="noreferrer"
              >
                <div className="contact-icon">
                  <FaMapPin />
                </div>
                <p>256 S South Pine Road, Enoggera, QLD 4051</p>
              </a>
              <a
                className="email-container contact-wrapper"
                href="mailto:hello@flowautobody.com.au"
              >
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <p>hello@ﬂowautobody.com.au</p>
              </a>
              <div className="schedule">
                <h2>Opening Hours</h2>
                <p>Monday - Friday: 7:00am - 3:00pm</p>
                <p>Saturday by appointment only</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
